import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IReportsCustomerSalesDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IReportsCustomerSalesDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  KuikaB2B_OrderSalesCustomerDetailMobile: any[];
  KuikaB2B_OrderSalesCustomerDetailMobile_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
}

export class ReportsCustomerSalesDetail_ScreenBase extends React.PureComponent<
  IReportsCustomerSalesDetail_ScreenProps,
  any
> {
  reportscustomersalesdetail_845263_value_kuikaTableRef: React.RefObject<any>;
  reportscustomersalesdetail_811321_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 927868,
          PropertyName: "value",
          Value: "Rapor Detay",
          TagName: "Label17_value",
        },
        {
          Id: 817950,
          PropertyName: "value",
          Value: "Sipariş Raporu Detay",
          TagName: "Label2_value",
        },
        {
          Id: 799205,
          PropertyName: "label",
          Value: "Export",
          TagName: "Button3_label",
        },
        {
          Id: 189173,
          PropertyName: "value",
          Value: "Koleksiyon Adı",
          TagName: "Label29_value",
        },
        {
          Id: 754279,
          PropertyName: "value",
          Value: "Desen Adı",
          TagName: "Label31_value",
        },
        {
          Id: 873162,
          PropertyName: "value",
          Value: "Ebat Adı",
          TagName: "Label33_value",
        },
        {
          Id: 933704,
          PropertyName: "value",
          Value: "Adet",
          TagName: "Label35_value",
        },
        {
          Id: 639874,
          PropertyName: "value",
          Value: "Metrekare",
          TagName: "Label37_value",
        },
        {
          Id: 303269,
          PropertyName: "value",
          Value: "Kalan Metrekare",
          TagName: "Label39_value",
        },
        {
          Id: 84622279,
          PropertyName: "d9a9067e-3f9c-b9ae-324b-f467fc75d2dd_confirmation",
          Value: "Raporu Excel Olarak Almak İstiyor Musunuz?",
          TagName: "ExportExcel_confirmation",
          IsConfirmation: true,
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 927868,
          PropertyName: "value",
          Value: "Report Detail",
          TagName: "Label17_value",
        },
        {
          Id: 817950,
          PropertyName: "value",
          Value: "Order Report Detail",
          TagName: "Label2_value",
        },
        {
          Id: 799205,
          PropertyName: "label",
          Value: "Export",
          TagName: "Button3_label",
        },
        {
          Id: 189173,
          PropertyName: "value",
          Value: "Collection Name",
          TagName: "Label29_value",
        },
        {
          Id: 754279,
          PropertyName: "value",
          Value: "Pattern Name",
          TagName: "Label31_value",
        },
        {
          Id: 873162,
          PropertyName: "value",
          Value: "Size Name",
          TagName: "Label33_value",
        },
        {
          Id: 933704,
          PropertyName: "value",
          Value: "Quantity",
          TagName: "Label35_value",
        },
        {
          Id: 639874,
          PropertyName: "value",
          Value: "Square meters",
          TagName: "Label37_value",
        },
        {
          Id: 303269,
          PropertyName: "value",
          Value: "Remaining Square Meters",
          TagName: "Label39_value",
        },
        {
          Id: 52774656,
          PropertyName: "d9a9067e-3f9c-b9ae-324b-f467fc75d2dd_confirmation",
          Value: "Do you want to receive the report as an Excel file?",
          TagName: "ExportExcel_confirmation",
          IsConfirmation: true,
        },
        {
          Id: 2358680,
          PropertyName: "7cf7a687-0877-8255-3ec0-a50afc61daf2_notify",
          Value: "Report Successfully Generated",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "bbc3067c-a8c6-440a-a694-968ae94c0192",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 927868, PropertyName: "value", Value: "Rapor Detay" },
        { Id: 817950, PropertyName: "value", Value: "Sipariş Raporu Detay" },
        { Id: 799205, PropertyName: "label", Value: "Export" },
        { Id: 617570, PropertyName: "title", Value: "Title" },
        { Id: 189173, PropertyName: "value", Value: "Koleksiyon Adı" },
        {
          Id: 687634,
          PropertyName: "value",
          Value: "[datafield:productatt03desc]",
        },
        { Id: 754279, PropertyName: "value", Value: "Desen Adı" },
        {
          Id: 703689,
          PropertyName: "value",
          Value: "[datafield:productatt05desc]",
        },
        { Id: 873162, PropertyName: "value", Value: "Ebat Adı" },
        {
          Id: 954642,
          PropertyName: "value",
          Value: "[datafield:productatt07desc]",
        },
        { Id: 933704, PropertyName: "value", Value: "Adet" },
        { Id: 373436, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 639874, PropertyName: "value", Value: "Metrekare" },
        { Id: 271633, PropertyName: "value", Value: "[datafield:qty2]" },
        { Id: 303269, PropertyName: "value", Value: "Kalan Metrekare" },
        {
          Id: 702922,
          PropertyName: "value",
          Value: "[datafield:remainingorderqty2]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.reportscustomersalesdetail_845263_value_kuikaTableRef =
      React.createRef();
    this.reportscustomersalesdetail_811321_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      KuikaB2B_OrderSalesCustomerDetailMobile: [],
      ExportExcel: "",
      Notify: false,
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "reportscustomersalesdetail",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.ReportsCustomerSalesDetailPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("reportscustomersalesdetail", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("reportscustomersalesdetail", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ReportsCustomerSalesDetailPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ReportsCustomerSalesDetailPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      orderNumberWS_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.orderNumber ??
          this.props.screenInputs.ordernumber,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsCustomerSalesDetail/ReportsCustomerSalesDetailPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerDetailMobile =
      result?.data.kuikaB2B_OrderSalesCustomerDetailMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ReportsCustomerSalesDetailPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsCustomerSalesDetailPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_845263 =
      stateVars.KuikaB2B_OrderSalesCustomerDetailMobile ??
      this.state.KuikaB2B_OrderSalesCustomerDetailMobile;
    formVars.reportscustomersalesdetail_811321_total =
      ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_OrderSalesCustomerDetailMobile !== undefined
          ? stateVars.KuikaB2B_OrderSalesCustomerDetailMobile?.length > 0
            ? stateVars.KuikaB2B_OrderSalesCustomerDetailMobile[0].totalRows
            : null
          : this.state.KuikaB2B_OrderSalesCustomerDetailMobile?.length > 0
          ? this.state.KuikaB2B_OrderSalesCustomerDetailMobile[0].totalRows
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ReportsCustomerSalesDetailComponent_111407_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsCustomerSalesDetailComponent_799205_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          this.state.KuikaB2B_OrderSalesCustomerDetailMobile
        ),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      footer_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "ProductAtt03Desc,ProductAtt05Desc,ProductAtt07Desc,Qty1,Qty2,RemainingOrderQty1,RemainingOrderQty2",
          "string"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d9a9067e_3f9c_b9ae_324b_f467fc75d2dd_confirmation",
        this.defaultML,
        "Raporu Excel Olarak Almak İstiyor Musunuz?"
      ),
      "poppins",
      "Confirmation",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ReportsCustomerSalesDetail/ReportsCustomerSalesDetailComponent_799205_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.ExportExcel = result?.data.exportExcel;
      ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsCustomerSalesDetailComponent_799205_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsCustomerSalesDetailComponent_799205_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "7cf7a687_0877_8255_3ec0_a50afc61daf2_notify",
        this.defaultML,
        "Rapor Başarıyla Oluşturuldu"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsCustomerSalesDetailComponent_811321_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      orderNumberWS_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.orderNumber ??
          this.props.screenInputs.ordernumber,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportscustomersalesdetail_811321_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsCustomerSalesDetail/ReportsCustomerSalesDetailComponent_811321_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerDetailMobile =
      result?.data.kuikaB2B_OrderSalesCustomerDetailMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsCustomerSalesDetailComponent_811321_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsCustomerSalesDetailComponent_811321_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_845263 =
      stateVars.KuikaB2B_OrderSalesCustomerDetailMobile ??
      this.state.KuikaB2B_OrderSalesCustomerDetailMobile;
    formVars.reportscustomersalesdetail_811321_total =
      ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_OrderSalesCustomerDetailMobile !== undefined
          ? stateVars.KuikaB2B_OrderSalesCustomerDetailMobile?.length > 0
            ? stateVars.KuikaB2B_OrderSalesCustomerDetailMobile[0].totalRows
            : null
          : this.state.KuikaB2B_OrderSalesCustomerDetailMobile?.length > 0
          ? this.state.KuikaB2B_OrderSalesCustomerDetailMobile[0].totalRows
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ReportsCustomerSalesDetailPageInit();
    }
  }
}
